(() => {
  const desktop = matchMedia('(min-width: 1024px)');
  const hover = matchMedia('(hover: hover)');
  const initializeBenefits = nav => {
    if (nav.dataset.benefitsReady) return;
    const header = nav.closest('.d2-header');
    const messages = header.querySelector('[data-d2-messages]');
    const serviceRow = header.querySelector('.d2-service-row');
    const picker = header.querySelector('rdb-emirate-picker');
    const list = nav.querySelector('.d2-desktop-nav__list');
    const support = list.querySelector('.d2-desktop-nav__item--support');
    if (!messages || !serviceRow || !picker || !support) return;
    nav.dataset.benefitsReady = 'true';
    const slot = document.createElement('li');
    slot.className = 'd2-desktop-nav__benefits-slot';
    slot.hidden = true;
    list.insertBefore(slot, support);
    const context = document.createElement('canvas').getContext('2d');
    let frame = 0;
    const place = () => {
      frame = 0;
      if (!header.isConnected) { observer.disconnect(); return; }
      let fits = false;
      if (desktop.matches) {
        const widths = [...messages.querySelectorAll('[data-d2-message]')].map(slide => {
          const style = getComputedStyle(slide);
          context.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
          return context.measureText(slide.querySelector('span:last-child').textContent.trim()).width;
        });
        const messageWidth = Math.ceil(Math.max(216, Math.max(...widths) + 92));
        header.style.setProperty('--d2-benefit-width', `${messageWidth}px`);
        header.style.setProperty('--d2-destination-width', `${Math.ceil(picker.getBoundingClientRect().width)}px`);
        const items = [...list.children].filter(item => item !== slot);
        const used = items.reduce((sum, item) => sum + item.getBoundingClientRect().width, 0);
        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        fits = used + gap * items.length + messageWidth + 32 <= list.clientWidth;
      }
      const destination = fits ? slot : serviceRow;
      if (messages.parentElement !== destination) {
        const focused = messages.contains(document.activeElement) ? document.activeElement : null;
        destination.append(messages);
        focused?.focus({ preventScroll: true });
      }
      slot.hidden = !fits;
      nav.dataset.benefitsDocked = String(fits);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(place); };
    const observer = new ResizeObserver(schedule);
    [list, picker, ...list.children].filter(item => item !== slot).forEach(item => observer.observe(item));
    desktop.addEventListener('change', schedule);
    document.fonts.ready.then(schedule);
    schedule();
  };
  const initialize = () => {
    document.querySelectorAll('.d2-header .d2-actions').forEach(actions => {
      const entries = [
        ['.account-button', actions.dataset.accountLabel],
        ['.rosarium-wishlist-header__link', actions.dataset.savedLabel],
        ['.cart-drawer > .header-actions__action, .action__cart', actions.dataset.cartLabel],
      ];
      entries.forEach(([selector, text]) => {
        const button = actions.querySelector(selector);
        if (!button || !text || button.querySelector('.d2-action-label')) return;
        const label = document.createElement('span');
        label.className = 'd2-action-label';
        label.textContent = text;
        label.setAttribute('aria-hidden', 'true');
        button.append(label);
      });
    });
    document.querySelectorAll('[data-desktop-nav]').forEach(nav => {
      initializeBenefits(nav);
      if (nav.dataset.initialized) return;
      nav.dataset.initialized = 'true';
      const disclosures = [...nav.querySelectorAll('details')];
      const timers = new Map();
      const close = () => disclosures.forEach(details => {
        clearTimeout(timers.get(details));
        details.open = false;
      });
      const open = details => {
        disclosures.forEach(other => {
          clearTimeout(timers.get(other));
          other.open = other === details;
        });
      };
      disclosures.forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) disclosures.forEach(other => {
            if (other !== details) {
              clearTimeout(timers.get(other));
              other.open = false;
            }
          });
        });
        details.addEventListener('pointerenter', event => {
          clearTimeout(timers.get(details));
          if (desktop.matches && hover.matches && event.pointerType !== 'touch') timers.set(details, setTimeout(() => open(details), 180));
        });
        details.addEventListener('pointerleave', () => {
          clearTimeout(timers.get(details));
          if (!details.querySelector(':focus-visible')) timers.set(details, setTimeout(() => details.open = false, 240));
        });
        details.addEventListener('focusout', event => {
          if (event.relatedTarget && !details.contains(event.relatedTarget)) {
            clearTimeout(timers.get(details));
            details.open = false;
          }
        });
      });
      nav.addEventListener('keydown', event => {
        const summary = event.target.closest('summary');
        if (summary && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
          event.preventDefault();
          const details = summary.closest('details');
          open(details);
          const links = [...details.querySelectorAll('a[href]')];
          (event.key === 'ArrowDown' ? links[0] : links.at(-1))?.focus();
          return;
        }
        const topItems = [...nav.querySelectorAll('.d2-desktop-nav__list > li > a, .d2-desktop-nav__list > li > details > summary')];
        const current = topItems.indexOf(event.target);
        if (current >= 0 && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const direction = getComputedStyle(nav).direction === 'rtl' ? -1 : 1;
          const step = (event.key === 'ArrowRight' ? 1 : -1) * direction;
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? topItems.length - 1 : (current + step + topItems.length) % topItems.length;
          close();
          topItems[next].focus();
          return;
        }
        if (event.key !== 'Escape') return;
        const opened = disclosures.find(details => details.open);
        if (!opened) return;
        event.preventDefault();
        close();
        opened.querySelector('summary').focus();
      });
      document.addEventListener('click', event => {
        if (!nav.contains(event.target)) close();
      });
      window.addEventListener('blur', close);
      desktop.addEventListener('change', close);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

(() => {
  if (window.rdbFreeShimmer || !('IntersectionObserver' in window)) return;
  window.rdbFreeShimmer = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const badges = new Map();
  let suspended = false;
  const update = (badge, state) => {
    const visible = state.visible && badge.isConnected && !document.hidden && !suspended && !motion.matches;
    state.shimmer.classList.toggle('is-visible', visible);
  };
  const updateAll = () => badges.forEach((state, badge) => update(badge, state));
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = badges.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.9;
      update(entry.target, state);
    });
  }, { threshold: [0, 0.9, 1] });
  const initialize = () => {
    document.querySelectorAll('body.rdb-design-2 .d2-header .d2-delivery__free').forEach(badge => {
      if (badges.has(badge)) return;
      const shimmer = document.createElement('span');
      shimmer.className = 'd2-free-shimmer';
      shimmer.setAttribute('aria-hidden', 'true');
      badge.append(shimmer);
      const state = { shimmer, visible: false };
      badges.set(badge, state);
      observer.observe(badge);
    });
  };
  document.addEventListener('visibilitychange', updateAll);
  motion.addEventListener('change', updateAll);
  window.addEventListener('pagehide', () => {
    suspended = true;
    updateAll();
  });
  window.addEventListener('pageshow', () => {
    suspended = false;
    updateAll();
  });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    badges.forEach((state, badge) => {
      if (!event.target.contains(badge)) return;
      observer.unobserve(badge);
      state.shimmer.remove();
      badges.delete(badge);
    });
  });
  initialize();
})();
